package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.screens.search.model.LocalSearchRequest
import com.eladfinish.bible.contest.screens.search.model.SearchPlaceData
import com.eladfinish.bible.contest.screens.search.mvi.SearchState

class BuildLocalSearchRequestUseCase {

    operator fun invoke(
        state: SearchState,
        originalExpression: String,
        regex: String,
        searchedChapters: List<SearchPlaceData>,
        isPremium: Boolean,
    ): LocalSearchRequest =
        LocalSearchRequest(
            originalExpression = originalExpression,
            regexInput = regex,
            withNikudAndTeamim = state.withNikudAndTeamim,
            withNikud = state.withNikud,
            withTeamim = state.withTeamim,
            onlyQri = state.onlyQri,
            searchMode = state.searchMode,
            searchedChapters = searchedChapters,
            isPremium = isPremium,
        )
}
